/** Keep the marker on-chart so the "Your offer" badge is not clipped. */
const MARKER_MIN_PCT = 4
const MARKER_MAX_PCT = 96
const MEDIAN_PCT = 50

const clampMarkerPct = (pct: number) => Math.max(MARKER_MIN_PCT, Math.min(MARKER_MAX_PCT, pct))

/**
 * Place an equity grant on the FAST market bell chart.
 *
 * The SVG peak and the "Median" x-axis label are at 50%. Low/high FAST outliers are not
 * symmetric around Strategic (e.g. Pre-seed 0.25 → 0.75 → 1.50), so a single linear
 * scale puts 0.75 at 40%. Map each side of the median separately so the recommendation
 * sits on the peak when it equals the labeled median.
 */
export const marketDistributionMarkerPercent = ({
  equity,
  low,
  median,
  high,
}: {
  equity: number
  low: number
  median: number
  high: number
}): number => {
  if (
    !Number.isFinite(equity) ||
    !Number.isFinite(low) ||
    !Number.isFinite(median) ||
    !Number.isFinite(high)
  ) {
    return MEDIAN_PCT
  }
  if (equity <= median) {
    if (median <= low) {
      return MEDIAN_PCT
    }
    const t = (equity - low) / (median - low)
    return clampMarkerPct(t * MEDIAN_PCT)
  }
  if (high <= median) {
    return MEDIAN_PCT
  }
  const t = (equity - median) / (high - median)
  return clampMarkerPct(MEDIAN_PCT + t * (100 - MEDIAN_PCT))
}
